import { useQuery } from '@tanstack/vue-query';
import { api } from '@/utils/api';
import { useAuth } from '@/composables/useAuth';

export const useRefreshToken = () => {
  const auth = useAuth();

  return useQuery({
    queryKey: ['refreshToken'],
    queryFn: () => api.post('/refresh-token').catch(() => auth.logout()),
    refetchInterval: 300000, // 5min,
    refetchIntervalInBackground: true,
    enabled: auth.isLoggedIn,
    refetchOnWindowFocus: false,
  });
};
